import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "react-perfect-scrollbar/dist/css/styles.css";
import "nprogress/nprogress.css";

import { createElement } from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { Amplify } from "aws-amplify";
import { enableES5 } from "immer";

import { configureStore } from "redux/store";
import { AWS_AMPLIFY } from "settings/aws";
import { initSettings } from "utils/settings";

import App from "./App";
import "./locales";

enableES5();

const store = configureStore();
const COMPANY_STORAGE_KEY = "company";

function parseIfValidJSON(value) {
  try {
    return JSON.parse(value);
  } catch (error) {
    return null;
  }
}

function buildCompanyFromSettings(settings = {}) {
  const company = settings?.company || {};
  const companyConfig =
    company?.site?.config ??
    company?.config ??
    settings?.company?.site?.config ??
    {};

  return {
    id: company?.id ?? null,
    name: company?.name ?? "Maxxa",
    logo: company?.logo ?? settings?.logo ?? null,
    theme: company?.theme ?? settings?.theme ?? {},
    config: companyConfig,
  };
}

function initCompanyStorage(settings = {}) {
  const rawCompany = localStorage.getItem(COMPANY_STORAGE_KEY);
  const existingCompany = parseIfValidJSON(rawCompany);
  const fallbackCompany = buildCompanyFromSettings(settings);

  if (
    existingCompany &&
    typeof existingCompany === "object" &&
    !Array.isArray(existingCompany)
  ) {
    const mergedCompany = {
      ...fallbackCompany,
      ...existingCompany,
      theme: {
        ...(fallbackCompany.theme || {}),
        ...(existingCompany.theme || {}),
      },
      config: {
        ...(fallbackCompany.config || {}),
        ...(existingCompany.config || {}),
      },
    };

    localStorage.setItem(COMPANY_STORAGE_KEY, JSON.stringify(mergedCompany));
    return;
  }

  localStorage.setItem(COMPANY_STORAGE_KEY, JSON.stringify(fallbackCompany));
}

if (navigator && navigator.serviceWorker) {
  navigator.serviceWorker.getRegistrations().then(function (registrations) {
    for (const registration of registrations) {
      registration.unregister();
    }
  });
}

const bootstrap = async () => {
  const settings = await initSettings();

  initCompanyStorage(settings);

  Amplify.configure(AWS_AMPLIFY);

  ReactDOM.render(
    createElement(Provider, {
      children: createElement(App),
      store,
    }),
    document.getElementById("root"),
  );
};

bootstrap();
